// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PorticoPortalChildModel {
    'id'?: string;
    'portalId'?: string;
    'childId'?: string;
    'createdBy'?: number;
    'createdOn'?: Moment;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PorticoPortalChildModel>> = [
        {
            "name":     "id",
            "baseName": "id",
            "type":     "string"
        },
        {
            "name":     "portalId",
            "baseName": "portalId",
            "type":     "string"
        },
        {
            "name":     "childId",
            "baseName": "childId",
            "type":     "string"
        },
        {
            "name":     "createdBy",
            "baseName": "createdBy",
            "type":     "number"
        },
        {
            "name":     "createdOn",
            "baseName": "createdOn",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return PorticoPortalChildModel.attributeTypeMap;
    }
}
